export default "__VITE_ASSET__BCObUIsH__"